import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '../icons/HomeIcon';
import MeetingsIcon from '../icons/MeetingsIcon';
import LiveMeetingsIcon from '../icons/LiveMeetingsIcon';
import UserIcon from '../icons/UserIcon';
import { useAuth } from '../../contexts/AuthContext';

const AppSidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, user, logout } = useAuth();
  const path = location.pathname;

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  const homeActive =
    path === '/dashboard' ||
    path === '/' ||
    path === '/dashboard/projects' ||
    path.startsWith('/dashboard/project/');

  const liveMeetingsActive = path === '/meetings/live';
  const meetingsActive = path.startsWith('/meetings') && !liveMeetingsActive;

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="logo-container" onClick={() => navigate('/dashboard')} style={{ cursor: 'pointer' }}>
          <img
            src="/images/FinancialSolutions_mark_rgb.png"
            alt="Strategy Observer Logo"
            className="logo-image"
          />
        </div>
      </div>
      <nav className="nav-menu">
        <button
          className={`nav-item ${homeActive ? 'active' : ''}`}
          onClick={() => navigate('/dashboard')}
          title="Home"
        >
          <HomeIcon className="nav-icon" size={24} />
        </button>
        <button
          className={`nav-item ${meetingsActive ? 'active' : ''}`}
          onClick={() => navigate('/meetings')}
          title="Meetings"
        >
          <MeetingsIcon className="nav-icon" size={24} />
        </button>
        <button
          className={`nav-item ${liveMeetingsActive ? 'active' : ''}`}
          onClick={() => navigate('/meetings/live')}
          title="Live meetings"
        >
          <LiveMeetingsIcon className="nav-icon" size={24} />
        </button>
      </nav>
      {isAuthenticated && (
        <div className="nav-menu nav-menu-bottom">
          <button
            className={`nav-item ${path === '/profile' ? 'active' : ''}`}
            onClick={() => navigate('/profile')}
            title={user ? `User settings (${user.display_name})` : 'User settings'}
          >
            <UserIcon className="nav-icon" size={24} />
          </button>
          <button className="nav-item" onClick={handleLogout} title="Sign out">
            <span className="nav-icon" style={{ fontSize: 20 }}>⏻</span>
          </button>
        </div>
      )}
    </aside>
  );
};

export default AppSidebar;
